/** After patient switch + mock open: replay deferred ECG only once the host has reloaded. */
const KEY = 'voicnav:pendingModalityAfterReload'

export function stagePendingModalityReplayAfterReload(): void {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(KEY, '1')
  } catch {
    /* ignore */
  }
}

export function consumePendingModalityReplayAfterReload(): boolean {
  if (typeof sessionStorage === 'undefined') return false
  try {
    if (sessionStorage.getItem(KEY) !== '1') return false
    sessionStorage.removeItem(KEY)
    return true
  } catch {
    return false
  }
}
